import { parseEntityRef } from '@backstage/catalog-model';

/**
 * Convert a Backstage entity ref (e.g. "user:default/joel-harley") to its
 * catalog page URL ("/catalog/default/user/joel-harley"), honouring custom
 * namespace and kind on the ref.
 *
 * Lives in shared/ rather than inline in each component because several
 * team-management components need this same conversion (manager chain,
 * direct-reports card, members card, teams card). Future Backstage routing
 * changes only need updating in one place.
 *
 * @param ref - the entity ref string, with or without explicit kind/namespace
 * @param defaults - optional overrides for the assumed kind/namespace when
 *                   the ref omits them (defaults to user/default)
 */
export function entityRefToCatalogPath(
  ref: string,
  defaults: { defaultKind?: string; defaultNamespace?: string } = {},
): string {
  const { kind, namespace, name } = parseEntityRef(ref, {
    defaultKind: defaults.defaultKind ?? 'user',
    defaultNamespace: defaults.defaultNamespace ?? 'default',
  });
  return `/catalog/${namespace.toLowerCase()}/${kind.toLowerCase()}/${name}`;
}
